import GameState from 'slotworks/model/game-state';
import ScatterResult from 'slotworks/model/gameplay/records/results/scatter-result';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import { Exit } from 'slotworks/state-machine/data/exit';
import Decision from 'slotworks/state-machine/decisions/decision';

export default class IsFreeSpinEnterCheck extends Decision {
    public evaluate() {
        let record = GameState.getCurrentGame().getCurrentRecord();
        let triggered = false;

        if (record instanceof SpinRecord) {
            triggered = record.freespinsTriggered;
        }

        if (record.beenPaid) {
            triggered = false;
        }

        const r = record.getResultsOfType(ScatterResult) as ScatterResult[];
        if (r && r[0] && r[0].matches >= 3) {
            triggered = true;
        }

        return triggered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./src/desicions/free-spin-enter-check.ts